<template>
  <transition name="fade">
    <table style="width: 98%">
      <tr>
        <!-- półka {{product}} -->
        <td rowspan="2" :class="mthGetClassForSwmApolka()">
          <div class="boxcaption">półka</div>
          <div class="custom-control custom-switch">
            <input
              v-on:change="mthSwitchPolka();$emit('boxchanged',product)"
              type="checkbox"
              class="custom-control-input"
              :id="'switcha'+product.id"
              :checked="mthIntToBool(product.swmApolka_wlaczone)"
            />
            <label class="custom-control-label" :for="'switcha'+product.id"></label>
          </div>

          <template v-if="mthIntToBool(product.swmApolka_wlaczone)">
            <div class="caption">Ilość:</div>
            <div class="bigbold">{{product.swmApolka}}</div>
            <hr class="hrhr" />max:
            <input
              type="number"
              v-model="product.swmApolka_max"
              class="inputmax"
              v-on:change="$emit('boxchanged',product)"
            />
          </template>
        </td>
        <td class="vcenter buttonsblock" align="center">
          <nobr v-if="product.swmApolka_wlaczone==1 && product.swmBpodreczny_wlaczone==1">
            <mdb-btn
              @click="mthShift('a','b',moveGreenAB*(-1))"
              class="smallButton"
              icon="arrow-left"
              gradient="blue"
            ></mdb-btn>
            <input v-model="moveGreenAB" type="number" class="inpmover" />
            <mdb-btn
              @click="mthShift('a','b',moveGreenAB)"
              class="smallButton"
              icon="arrow-right"
              gradient="blue"
            ></mdb-btn>
          </nobr>
        </td>
        <!-- podręczny -->
        <td :class="mthGetClassForSwmBpodreczny()">
          <div class="boxcaption">podręczny</div>
          <div class="custom-control custom-switch">
            <input
              v-on:change="mthSwitchPodreczny();$emit('boxchanged',product)"
              type="checkbox"
              class="custom-control-input"
              :id="'switchb'+product.id"
              :checked="mthIntToBool(product.swmBpodreczny_wlaczone)"
            />
            <label class="custom-control-label" :for="'switchb'+product.id"></label>
          </div>
          <template v-if="mthIntToBool(product.swmBpodreczny_wlaczone)">
            <div class="caption">Ilość:</div>
            <div class="bigbold">{{product.swmBpodreczny}}</div>
            <hr class="hrhr" />max:
            <input
              type="number"
              v-model="product.swmBpodreczny_max"
              class="inputmax"
              v-on:change="$emit('boxchanged',product)"
            />
          </template>
        </td>
        <td class="vcenter buttonsblock" align="center">
          <template
            v-if="mthIntToBool(product.swmCpalety_wlaczone) &&  product.swmBpodreczny_wlaczone==1"
          >
            <nobr>
              <mdb-btn
                @click="mthShift('b','c',moveGreenBC*(-1))"
                class="smallButton"
                icon="arrow-left"
                gradient="blue"
              ></mdb-btn>
              <input v-model="moveGreenBC" type="number" class="inpmover" />
              <mdb-btn
                @click="mthShift('b','c',moveGreenBC)"
                class="smallButton"
                icon="arrow-right"
                gradient="blue"
              ></mdb-btn>
            </nobr>
          </template>
        </td>
        <!-- palety -->
        <td rowspan="2" :class="mthGetClassForSwmCpalety()">
          <div class="boxcaption">palety</div>
          <div class="custom-control custom-switch">
            <input
              v-on:change="mthSwitchPalettes();$emit('boxchanged',product)"
              type="checkbox"
              class="custom-control-input"
              :id="'switchc'+product.id"
              :checked="mthIntToBool(product.swmCpalety_wlaczone)"
            />
            <label class="custom-control-label" :for="'switchc'+product.id"></label>
          </div>

          <template v-if="mthIntToBool(product.swmCpalety_wlaczone)">
            <div class="caption">Ilość:</div>
            <div class="bigbold">{{product.swmCpalety}}</div>
            <hr class="hrhr" />lokalizacje
            <br />
            <textarea
              maxlength="60"
              type="text"
              v-model="product.swmCpalety_opis"
              class="txtarea"
              v-on:change="$emit('boxchanged',product)"
            />
          </template>
        </td>
      </tr>
      <tr>
        <td class="vcenter" colspan="3">
          <div
            class="bottomArrows"
            v-if="mthIntToBool(product.swmCpalety_wlaczone) && product.swmApolka_wlaczone==1"
          >
            <mdb-btn
              @click="mthShift('a','c',moveGreenAC*(-1))"
              class="widebutton"
              icon="arrow-left"
              gradient="blue"
            ></mdb-btn>
            <input v-model="moveGreenAC" type="number" class="inpmover" />
            <mdb-btn
              @click="mthShift('a','c',moveGreenAC)"
              class="widebutton"
              icon="arrow-right"
              gradient="blue"
            ></mdb-btn>
          </div>
        </td>
      </tr>
      <!-- dostawa, shipment -->
      <tr v-if="shippingModeWatched" class="trship">
        <td>
          <input v-model="shipA" placeholder="dostawa" class="ship" />
        </td>
        <td>
          <nobr>
            <mdb-btn
              @click="mthShiftInShipment('a','b',moveGreenShipAB*(-1))"
              class="smallButton"
              icon="arrow-left"
              gradient="blue"
            ></mdb-btn>
            <input v-model="moveGreenShipAB" type="number" class="inpmover" />
            <mdb-btn
              @click="mthShiftInShipment('a','b',moveGreenShipAB)"
              class="smallButton"
              icon="arrow-right"
              gradient="blue"
            ></mdb-btn>
          </nobr>
        </td>
        <td>
          <input v-model="shipB" placeholder="dostawa" class="ship" />
        </td>
        <td>
          <nobr>
            <mdb-btn
              @click="mthShiftInShipment('b','c',moveGreenShipBC*(-1))"
              class="smallButton"
              icon="arrow-left"
              gradient="blue"
            ></mdb-btn>
            <input v-model="moveGreenShipBC" type="number" class="inpmover" />
            <mdb-btn
              @click="mthShiftInShipment('b','c',moveGreenShipBC)"
              class="smallButton"
              icon="arrow-right"
              gradient="blue"
            ></mdb-btn>
          </nobr>
        </td>
        <td>
          <input v-model="shipC" placeholder="dostawa" class="ship" />
        </td>
      </tr>
    </table>
  </transition>
</template>

<script>
import { mdbIcon } from "mdbvue";
import { mdbBtn } from "mdbvue";

export default {
  name: "Boxes",
  props: {
    product: Object,
    shippingModeWatched: Boolean,
    rewriteShipmentToBigboldiesRequestWatched: Boolean
  },
  data() {
    return {
      shipA: 0,
      shipB: 0,
      shipC: 0,
      moveGreenAB: 0,
      moveGreenShipAB: 0,
      moveGreenBC: 0,
      moveGreenShipBC: 0,
      moveGreenAC: 0
    };
  },
  created() {
    //console.log(this.product);
    //if(this.shippingMode) this.mthEnrichInputs();
  },
  watch: {
    rewriteShipmentToBigboldiesRequestWatched: function(newVal, oldVal) {
      //console.log('yy');

      if (newVal) {
        //console.log("jeah");

        this.mthCopyShipmentToBigboldies();
      }
    },
    shippingModeWatched: function(newVal, oldVal) {
      //console.log("Prop changed: ", newVal, " | was: ", oldVal);
      // if (newVal) {
      //   console.log("on");

      //console.log(this.product.swmWlaczony)

      if (this.product.swmWlaczony == 1 && newVal) this.mthEnrichInputs();
    }
  },
  methods: {
    mthGetClassForSwmCpalety() {
      if (this.product.swmCpalety_wlaczone == 0) return "b gray colorbox";
      return "b blue colorbox";
    },
    mthGetClassForSwmBpodreczny() {
      if (this.product.swmBpodreczny_wlaczone == 0) return "b gray colorbox";
      return "b yellow colorbox";
    },
    mthGetClassForSwmApolka() {
      if (this.product.swmApolka_wlaczone == 0) return "b gray colorbox";
      return "b orange colorbox";
    },
    mthShift(from, to, amount) {
      console.log("sh" + from + to + amount);

      if (from == "a")
        this.product.swmApolka =
          parseInt(this.product.swmApolka) - parseInt(amount);
      if (from == "b")
        this.product.swmBpodreczny =
          parseInt(this.product.swmBpodreczny) - parseInt(amount);
      if (from == "c")
        this.product.swmCpalety =
          parseInt(this.product.swmCpalety) - parseInt(amount);

      if (to == "a")
        this.product.swmApolka =
          parseInt(this.product.swmApolka) + parseInt(amount);
      if (to == "b")
        this.product.swmBpodreczny =
          parseInt(this.product.swmBpodreczny) + parseInt(amount);
      if (to == "c")
        this.product.swmCpalety =
          parseInt(this.product.swmCpalety) + parseInt(amount);
    },
    mthShiftInShipment(from, to, amount) {
      console.log("shiftinshipment" + from + to + amount);

      if (from == "a")
      {
        this.shipA = parseInt(this.shipA) - parseInt(amount);
        this.shipB = parseInt(this.shipB) + parseInt(amount);
      }
      if (from == "b")
      {
        this.shipB =
          parseInt(this.shipB) - parseInt(amount);
        this.shipC =
          parseInt(this.shipC) + parseInt(amount);

      }
    },

    mthCopyShipmentToBigboldies() {
      console.log("copying shipment to boldies");

      this.product.swmApolka = this.shipA;
      this.product.swmBpodreczny = this.shipB;
      this.product.swmCpalety = this.shipC;

      this.$emit("shipment-copied-to-big-boldies");
    },
    mthFindPlaceInABC() {
      if (this.product.swmWlaczony == 1) {
        if (
          this.product.swmApolka_wlaczone == 1 &&
          parseInt(this.product.swmApolka) + this.shipA <
            this.product.swmApolka_max
        )
          return "A";

        if (
          this.product.swmBpodreczny_wlaczone == 1 &&
          parseInt(this.product.swmBpodreczny) + this.shipB <
            this.product.swmBpodreczny_max
        )
          return "B";

        if (this.product.swmCpalety_wlaczone == 1) return "C";
      }

      return "NOTFOUND";
    },
    mthEnrichRemains() {
      var ret = 0;

      ret =
        parseInt(this.product.stan_cache) -
        parseInt(this.mthSumBoldiesABC()) -
        parseInt(this.shipA) -
        parseInt(this.shipB) -
        parseInt(this.shipC);

      console.log("enrich says: " + ret);

      return ret;
    },
    mthEnrichInputs() {
      //console.log("aaa");

      this.shipA = 0;
      this.shipB = 0;
      this.shipC = 0;

      //console.log(sumABC);

      var amountToDispose =
        parseInt(this.product.stan_cache) - this.mthSumBoldiesABC();

      console.log("enrich has to dispose: ");
      console.log(amountToDispose);

      //for (var i = 1; i <= amountToDispose; i++) {

      var that = this;

      if(amountToDispose>0) var fun = setInterval(function() {
        var found = that.mthFindPlaceInABC();
        var omit = false;
        //console.log(found)

        if (that.mthEnrichRemains() == 0 || found == "NOTFOUND") {
          console.log("stopping");

          clearInterval(fun);
          omit = true;
        }

        if (!omit) {
          if (found == "A") that.shipA++;
          else if (found == "B") that.shipB++;
          else if (found == "C") that.shipC++;
        }
        //else ;
      }, 10);
      //}
    },
    mthSumBoldiesABC() {
      var ret = 0;

      if (this.product.swmWlaczony == 1) {
        if (this.product.swmApolka_wlaczone && this.product.swmApolka > 0)
          ret += parseInt(this.product.swmApolka);
        if (
          this.product.swmBpodreczny_wlaczone &&
          this.product.swmBpodreczny > 0
        )
          ret += parseInt(this.product.swmBpodreczny);
        if (this.product.swmCpalety_wlaczone && this.product.swmCpalety > 0)
          ret += parseInt(this.product.swmCpalety);
      }
      //console.log(ret);

      return ret;

      //return 0;
    },

    mthEmitChangeInProduct() {
      console.log("mth to emit fired");
      this.$emit("product-changed-in-boxes");
    },
    mthSwitchPolka() {
      if (this.product.swmApolka_wlaczone == 0)
        this.product.swmApolka_wlaczone = 1;
      else this.product.swmApolka_wlaczone = 0;
    },
    mthSwitchPodreczny() {
      if (this.product.swmBpodreczny_wlaczone == 0)
        this.product.swmBpodreczny_wlaczone = 1;
      else this.product.swmBpodreczny_wlaczone = 0;
    },
    mthSwitchPalettes() {
      if (this.product.swmCpalety_wlaczone == 0)
        this.product.swmCpalety_wlaczone = 1;
      else this.product.swmCpalety_wlaczone = 0;
    },
    mthIntToBool(value) {
      //console.log('got '+value)

      if (value == 1) return true;
      if (value == "1") return true;
      return false;
    }
  },
  components: {
    mdbBtn
  }
};
</script>

<style scoped>
td.b {
  border: 5px solid gray;
  vertical-align: top;
  padding: 2px;
  text-align: center;
}
div.bigbold {
  margin: 0;
  padding: 0;
  font-size: 2rem;
  line-height: 2rem;
}
div.caption {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}
.orange {
  background-color: orange;
}
.gray {
  background-color: gray;
}
.yellow {
  background-color: yellow;
}
.blue {
  background-color: lightblue;
}
.hrhr {
  border-top: 2px solid mediumpurple;
  padding: 0;
  margin: 0;
}
.inputmax {
  display: block;
  width: 50px;
  margin-left: auto;
  margin-right: auto;
}
.inputwide {
  display: block;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.inpmover {
  background-color: yellowgreen;
  border-color: green;
  margin-left: auto;
  margin-right: auto;
  min-width: 30px;
  max-width: 40px;
  height: 1.8rem;
  text-align: center;
}
.vcenter {
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}
.nonobr {
  break-inside: avoid;
}
.txtarea {
  min-height: 90px;
  width: 90px;
  background-color: lightskyblue;
}
.bottomArrows {
  display: flex;
}
.widebutton {
  width: 120px;
  height: 30px;
  padding-top: 0px;
  margin-top: -1px;
}
.smallButton {
  padding: 0;
  width: 30px;
  height: 30px;
  margin-top: -1px;
}
.colorbox {
  min-width: 100px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.buttonsblock {
  min-width: 145px;
  max-width: 150px;
}
.ship {
  width: 95%;
}
.trship {
  background-color: #91ffff;
}
</style>
